export default __webpack_public_path__ + "static/media/contrast_dark_background.e2726f17.svg";